<template>
  <div style="width: 100%">
    <a-button type="primary" style="margin-bottom: 16px" @click="toggleCollapsed">
      <a-icon :type="collapsed ? 'menu-unfold' : 'menu-fold'" />
    </a-button>
    <a-menu
      :default-open-keys="['1']"
      :default-selected-keys="defaultSelectedKeys"
      mode="inline"
      theme="dark"
      :inline-collapsed="collapsed"
      @select="sendCategory"
    >
      <template v-for="item in list">
        <a-menu-item v-if="!item.children" :key="item.key">
          <a-icon type="pie-chart" />
          <span>{{ item.title }}</span>
        </a-menu-item>
        <sub-menu v-else :key="item.key" :menu-info="item" />
      </template>
    </a-menu>
  </div>
</template>

<script>
import { Menu } from "ant-design-vue";
const SubMenu = {
  template: `
      <a-sub-menu :key="menuInfo.key" v-bind="$props" v-on="$listeners">
        <span slot="title">
          <a-icon type="folder" />{{ menuInfo.title }}</span>
        </span>
        <template v-for="item in menuInfo.children">
          <a-menu-item v-if="!item.children" :key="item.key">
            <a-icon type="file-zip" />
            <span>{{ item.title }}</span>
          </a-menu-item>
          <sub-menu v-else :key="item.key" :menu-info="item" />
        </template>
      </a-sub-menu>
    `,
  name: "SubMenu",
  // must add isSubMenu: true
  isSubMenu: true,
  props: {
    ...Menu.SubMenu.props,
    // Cannot overlap with properties within Menu.SubMenu.props
    menuInfo: {
      type: Object,
      default: () => ({}),
    },
  },
};
export default {
  components: {
    "sub-menu": SubMenu,
  },
  data(){
    return {
      list:[],
      collapsed:'true',
      defaultSelectedKeys:['1']
    }
  },
  created:function(){
    this.axios.get('menu.php')
      .then(response => (this.list=response.data.res.list));

    this.sendCategory({'key':this.defaultSelectedKeys});
  },
  methods: {
    toggleCollapsed() {
      this.collapsed = !this.collapsed;
    },
    sendCategory(parameter) {
      this.$emit('getFileObj',parameter);
    },
  },
};
</script>